import React, { useContext, useState, useEffect } from 'react'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { DeleteOutline } from '@mui/icons-material'
import { LoadingContext, M_InputTextField } from '../M_Components'
import { HelpOutline } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import "../utils/utils.css"

export default function TableRangeKilometers({ id, PriceTableDetailList, setRowRange, columnsRange, dataQuotes, setDataQuotes, optionsRange, disabled = false }) {
  const ctx = useContext(LoadingContext)
  const { t } = useTranslation()
  const [calc, setCalc] = useState(0)

  useEffect(() => {
    const getValues = PriceTableDetailList.map(value => {
      const value1 = value.SimulatedVariableValue || 0
      const value2 = value.StandardPrice || 1
      const ratio = value1 === 0 ? 0 : value2 / value1
      return parseFloat(ratio.toFixed(3))
    })

    const calculo = getValues.reduce((acc, currentValue) => acc + currentValue, 0)
    setCalc(calculo)
  }, [PriceTableDetailList])


  const deleteRow = (rowData) => {
    const rowIndex = PriceTableDetailList.findIndex((row) => row.id === rowData.id);
    if (rowIndex !== -1 && PriceTableDetailList.length > 1) {
      const updatedTable = [...PriceTableDetailList]
      updatedTable.splice(rowIndex, 1)
      setRowRange(updatedTable)
      const newDataQuotes = new Map(dataQuotes)

      const newTableArray = newDataQuotes.get('PriceTableList').map(obj => {
        if (obj.PricePlanId == id) {
          const newObj = {
            ...obj,
            PriceTableDetailList: updatedTable,
          }
          return newObj
        } else {
          return obj
        }
      })

      newDataQuotes.set('PriceTableList', newTableArray)
      setDataQuotes(new Map(newDataQuotes))
      ctx.toastMessages('success', '', t("DeleteLine"))
    } else {
      ctx.toastMessages('error', '', t("ErrorDeletingLine"))
    }
  }

  const textInput = (rowData, code) => {
    const value = rowData[code] || '';

    if (code === "SimulatedUnitPrice") {
      return (
        <div>{calc}</div>
      )
    }
    return (
      <div style={{ width: '100%' }}>
        <M_InputTextField
          padding={'0 5px 0 5px'}
          height={'30px'}
          value={value === null || value === undefined ? '' : value}
          color={"var(--color-grey)"}
          disabled={disabled}
          onChange={(e) => {
            const inputValue = e.target.value
            const sanitizedValue = inputValue.replace(/,/g, '.')
            if (/^\d*\.?\d*$/.test(sanitizedValue)) {
              editField(rowData, code, sanitizedValue);
            }
          }}
        />
      </div>
    )
  }


  const editField = (rowData, code, data) => {
    const updatedRows = PriceTableDetailList.map((obj) => {
      if (obj.id === rowData.id) {
        return { ...obj, [code]: data }
      }
      return obj
    })
    setRowRange(updatedRows)
  }


  const dynamicColumns = columnsRange.map((col, i) => {
    const isLimitColumn = col.field === "From Kms"

    const isRangeQuote = dataQuotes.get("TypeQuotes") === 'Range Kilometers'
    const isSimulatedVariableValue = col.field === 'SimulatedVariableValue' || col.field === 'SimulatedUnitPrice'

    const isSpecificPrice = dataQuotes.get("TypeQuotes") === "Postal Code" || dataQuotes.get("TypeQuotes") === "Location Set" || dataQuotes.get("TypeQuotes") === 'Specific Price'
    const specificPrice = col.field === 'StandardExtraLimitPrice' || col.field === 'ReloadExtraLimitPrice' || col.field === 'ReloadPrice' || col.field === 'Limit'

    const isRangeTrips = dataQuotes.get("TypeQuotes") === 'Transfer'
    const rangeTrips = col.field === 'SimulatedVariableValue' || col.field === 'ReloadExtraLimitPrice' || col.field === 'ReloadPrice' || col.field === 'SimulatedUnitPrice' || col.field === 'StandardPrice' || col.field === 'Limit' //

    if (isSimulatedVariableValue && isRangeQuote) {
      return null
    }

    if (specificPrice && isSpecificPrice) {
      return null
    }

    if (rangeTrips && isRangeTrips) {
      return null
    }

    return (
      <Column
        key={i}
        field={col.field}
        header={
          <div>
            <span className='divAlignHeaderTable'>
              {isLimitColumn ? (
                <span>{dataQuotes.get("TypeQuotes") === 'Transfer' ? 'From Voyages' : 'From Kms'}</span>
              ) : (
                <>
                  {col.header}
                  {!isLimitColumn && (
                    dataQuotes.get("IsEmptyContainer") ?
                      <div className='divButtonInfo' onClick={() => showColumnInfo(col.header)}>
                        <div className='iconHelpTable'>
                          <HelpOutline />
                        </div>
                      </div>
                      : ""
                  )}
                </>
              )}
            </span>
          </div>
        }
        body={(data) => textInput(data, col.field)}
      />
    )
  }).filter(Boolean)


  const showColumnInfo = (columnName) => {
    const tempDescription = optionsRange.find((elem) => elem.NormalizedName === columnName)
    const tempDes = tempDescription.Description
    if (dataQuotes.get("TypeQuotes") === 'Transfer') {
      if (dataQuotes.get("IsEmptyContainer") === true) {
        ctx.toastMessages('info', t("ExceptSaturdaySunday"), '')
      }
    } else {
      ctx.toastMessages('info', tempDes, '')

    }
  }

  return (
    <div>
      <DataTable
        className="dataTableVolumes"
        scrollable
        scrollHeight="300px"
        value={PriceTableDetailList}
        size="small"
        editMode="cell"
        showGridlines
        resizableColumns
        columnResizeMode="expand"
      >
        {dynamicColumns}
        {!disabled && (
          <Column
            style={{ maxWidth: '3em' }}
            body={(rowData) => (
              <DeleteOutline
                onClick={() => deleteRow(rowData)}
                style={{ cursor: 'pointer', color: 'var(--color-red)' }}
              />
            )}
          />
        )}
      </DataTable>
    </div>
  )
}
